module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "context-tree-select-mask",
    on: {
      "click": _vm.hideTreeSelectMenu
    }
  }, [_c('div', {
    staticClass: "context-tree-select",
    style: ({
      top: _vm.posY,
      left: _vm.posX
    })
  }, [(_vm.showOptions) ? _c('select', {
    on: {
      "change": _vm.selection,
      "click": _vm.preventEventBubbling
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Show in Tree ...")]), _vm._v(" "), _vm._l((_vm.entries), function(rootNode) {
    return _c('option', {
      domProps: {
        "value": rootNode.uri.slice('infobits.tree.'.length)
      }
    }, [_vm._v("\n        " + _vm._s(rootNode.uri.slice('infobits.tree.'.length)) + "\n      ")])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.showOptions) ? _c('span', {
    staticClass: "label"
  }, [_vm._v("Infobit is not yet assigned to any tree")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95bce2b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/context-tree-select.vue
// module id = 148
// module chunks = 0